// Утилита для предварительной загрузки изображений
const imageCache = new Map();

export const preloadImage = (url) => {
	if (!url) return Promise.resolve();
	if (imageCache.has(url)) return Promise.resolve(imageCache.get(url));

	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			imageCache.set(url, img);
			resolve(img);
		};
		img.onerror = reject;
		img.src = url;
	});
};

export const preloadImages = async (urls) => {
	const promises = urls.map(url => preloadImage(url));
	return Promise.allSettled(promises);
};

export const getCachedImage = (url) => {
	return imageCache.get(url);
};

export const clearImageCache = () => {
	imageCache.clear();
}; 